import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CTASection = ({
  eyebrow = "Get started",
  title = "Have a research or engineering challenge?",
  description = "Talk to our engineers about your motor, embedded, AI or aerospace project.",
  primary = { to: "/contact", label: "Contact us" },
  secondary = { to: "/technologies", label: "Explore technologies" },
}) => {
  return (
    <section
      data-testid="cta-section"
      className="relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl border border-slate-200 bg-[#0B1B3D] p-10 lg:p-14 overflow-hidden">
          <div className="absolute inset-0 bg-dots opacity-25" />
          <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-sky-500/10 blur-3xl" />
          <div className="absolute -left-16 -bottom-24 w-80 h-80 rounded-full bg-amber-500/10 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-medium mb-3">
                {eyebrow}
              </div>
              <h3 className="font-display text-3xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.05]">
                {title}
              </h3>
              <p className="mt-4 text-slate-300/85 max-w-2xl leading-relaxed">
                {description}
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-wrap gap-3 lg:justify-end">
              <Link
                to={primary.to}
                data-testid="cta-primary-button"
                className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-[#0B1B3D] font-semibold px-6 py-3.5 rounded-md transition-colors"
              >
                {primary.label}
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </Link>
              <Link
                to={secondary.to}
                data-testid="cta-secondary-button"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-amber-400 text-white px-6 py-3.5 rounded-md transition-colors"
              >
                {secondary.label}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
